import Vue from 'vue';
import Vuex from 'vuex';
import layouts from './modules/layouts';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    layouts
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  strict: false
});



// WEBPACK FOOTER //
// ./src/store/index.js